var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInceptLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.472,
    height: 151.44,
    viewBox: "0 0 154.472 151.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(2304.044 -752.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(-2304.044 858.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M-2304.044,1120.079a2.215,2.215,0,0,1,2.281-2.2,2.206,2.206,0,0,1,2.244,2.2v21.169a2.207,2.207,0,0,1-2.244,2.2,2.216,2.216,0,0,1-2.281-2.2Z",
    transform: "translate(2304.044 -1117.63)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M-2252.342,1120.151a2.245,2.245,0,0,1,2.281-2.233h.479a2.867,2.867,0,0,1,2.354,1.3l12.876,16.309v-15.481a2.19,2.19,0,0,1,2.207-2.159,2.2,2.2,0,0,1,2.244,2.159v21.169a2.175,2.175,0,0,1-2.208,2.2h-.184a2.863,2.863,0,0,1-2.354-1.332l-13.244-16.777v15.985a2.19,2.19,0,0,1-2.207,2.16,2.2,2.2,0,0,1-2.245-2.16Z",
    transform: "translate(2267.424 -1117.63)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M-2144.016,1130.121v-.072a12.893,12.893,0,0,1,13.282-13.033,13.7,13.7,0,0,1,8.829,2.845,2.2,2.2,0,0,1,.883,1.763,2.177,2.177,0,0,1-2.245,2.161,2.239,2.239,0,0,1-1.361-.433,9.463,9.463,0,0,0-6.144-2.267,8.563,8.563,0,0,0-8.5,8.892v.072c0,4.932,3.569,8.928,8.5,8.928a9.343,9.343,0,0,0,6.438-2.411,2.084,2.084,0,0,1,1.362-.5,2.13,2.13,0,0,1,2.133,2.052,2.107,2.107,0,0,1-.735,1.583,13.319,13.319,0,0,1-9.344,3.384,12.811,12.811,0,0,1-13.1-12.96",
    transform: "translate(2190.699 -1117.016)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M-2034.43,1141.468v-20.736a2.222,2.222,0,0,1,2.281-2.232h14.973a2.02,2.02,0,0,1,2.024,1.98,2,2,0,0,1-2.024,1.98H-2029.9v6.552h11.073a2.026,2.026,0,0,1,2.024,2.015,1.989,1.989,0,0,1-2.024,1.945H-2029.9v6.768h12.913a2.019,2.019,0,0,1,2.024,1.979,2,2,0,0,1-2.024,1.98h-15.158a2.223,2.223,0,0,1-2.281-2.233",
    transform: "translate(2113.081 -1118.068)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M-1927.541,1131.6c3.422,0,5.555-1.873,5.555-4.5v-.073c0-2.951-2.17-4.5-5.555-4.5h-5.26v9.072Zm-9.786-10.873a2.223,2.223,0,0,1,2.281-2.232h7.873c6.034,0,9.786,3.347,9.786,8.424V1127c0,5.652-4.634,8.6-10.3,8.6h-5.113v6.084a2.206,2.206,0,0,1-2.245,2.2,2.215,2.215,0,0,1-2.281-2.2Z",
    transform: "translate(2044.304 -1118.067)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M-1839.058,1122.6h-6.254a2.073,2.073,0,0,1-2.1-2.052,2.074,2.074,0,0,1,2.1-2.052h17.108a2.065,2.065,0,0,1,2.059,2.052,2.064,2.064,0,0,1-2.059,2.052h-6.293v19.081a2.237,2.237,0,0,1-2.28,2.2,2.238,2.238,0,0,1-2.281-2.2Z",
    transform: "translate(1980.617 -1118.067)",
    fill: "#273943"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(-2274.484 752.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M-2048.41,937.1c-.906-.037-1.845-.123-2.8-.257a17.627,17.627,0,0,0-.784,4.86,33.585,33.585,0,0,0,3.379.314,27.409,27.409,0,0,0,3.539-.079,21.819,21.819,0,0,0-.655-4.893,23.356,23.356,0,0,1-2.677.054",
    transform: "translate(2095.963 -882.989)",
    fill: "#009df0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M-2009.15,858.733a26.367,26.367,0,0,0,.8-4.89,30.9,30.9,0,0,0-16.471,3.109,31.6,31.6,0,0,1,3.873,3.677,25.913,25.913,0,0,1,11.8-1.9",
    transform: "translate(2076.716 -824.117)",
    fill: "#009df0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M-2129.779,806.164a30.822,30.822,0,0,1,1.34-5.105,24.919,24.919,0,0,1-7.821-9.51,23.126,23.126,0,0,1-2.16-9.794c0-.783.04-1.589.12-2.4l.039-.4.061-.013a24.841,24.841,0,0,1,24.966-21.787,26.107,26.107,0,0,1,18.6,7.772,22.359,22.359,0,0,1,6.481,14.046,21.919,21.919,0,0,1,.052,2.66,28.856,28.856,0,0,1-2.034,9.473,24.917,24.917,0,0,1-7.73,10.372,34.94,34.94,0,0,1,1.175,5.312,29.229,29.229,0,0,0,11.278-13.927,34.047,34.047,0,0,0,2.336-11c.014-.315.017-.63.019-.943A27.261,27.261,0,0,0-2091,761.536a31.214,31.214,0,0,0-22.238-9.294c-16.4,0-29.925,13.056-30.149,29.1l-.006.351-.061.058a27.969,27.969,0,0,0,2.468,11.5,29.809,29.809,0,0,0,11.2,12.9",
    transform: "translate(2160.738 -752.242)",
    fill: "#009df0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M-2081.906,869.281q-.286-.538-.593-1.056c-5.923-10.038-17.115-15.169-29.29-13.463a19.092,19.092,0,0,0,.809,4.9c10.369-1.37,19.993,3.265,24.619,11.9a25.13,25.13,0,0,1-1.375,26.65,27.211,27.211,0,0,0,3.924,3.115,30.272,30.272,0,0,0,1.906-32.049",
    transform: "translate(2138.313 -824.626)",
    fill: "#009df0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M-2194.238,908.043a24.8,24.8,0,0,1-2.422-19.649,22.624,22.624,0,0,1,8.74-12.2,32.11,32.11,0,0,1-1.264-5.1,27.658,27.658,0,0,0-12.3,15.916A29.658,29.658,0,0,0-2198.6,910.5c8.039,13.623,25.839,18.643,40.022,11.426a39,39,0,0,1-3.982-3.586,25.325,25.325,0,0,1-31.682-10.3",
    transform: "translate(2202.713 -836.424)",
    fill: "#009df0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M-2037.025,869.067a38.062,38.062,0,0,1-1.177,5.17,24.156,24.156,0,0,1,6.8,32.05,25.791,25.791,0,0,1-16.178,11.876,23.461,23.461,0,0,1-18.052-2.818l-.3-.2a30.811,30.811,0,0,1-4.884-3.872,25,25,0,0,1-7.567-14.508,21.821,21.821,0,0,1,1.9-12.271,23.09,23.09,0,0,1,1.5-2.717,26.762,26.762,0,0,1,1.667-2.285,18.274,18.274,0,0,0-3.939-3.053,31.437,31.437,0,0,0-1.977,2.7c-.222.342-.432.684-.637,1.031-.461.779-.894,1.6-1.288,2.453a26.413,26.413,0,0,0-2.491,12,29.331,29.331,0,0,0,8.832,19.711,35.466,35.466,0,0,0,4.782,4.024q.824.58,1.691,1.127a28.564,28.564,0,0,0,21.954,3.455,30.829,30.829,0,0,0,19.344-14.2,29.258,29.258,0,0,0-9.981-39.681",
    transform: "translate(2118.388 -834.987)",
    fill: "#009df0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-2288.172 894.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M-2249.333,1248.3a.724.724,0,0,1-.3-.589.718.718,0,0,1,.728-.715.715.715,0,0,1,.451.138,3.808,3.808,0,0,0,2.459.9c.953,0,1.555-.452,1.555-1.1v-.025c0-.627-.351-.966-1.982-1.342-1.869-.452-2.923-1-2.923-2.622v-.025c0-1.505,1.254-2.546,3-2.546a4.83,4.83,0,0,1,2.785.815.7.7,0,0,1,.339.615.717.717,0,0,1-.728.715.745.745,0,0,1-.4-.113,3.653,3.653,0,0,0-2.02-.665c-.9,0-1.43.464-1.43,1.041v.025c0,.677.4.979,2.095,1.38,1.857.452,2.81,1.116,2.81,2.572v.025c0,1.643-1.292,2.622-3.136,2.622A5.467,5.467,0,0,1-2249.333,1248.3Z",
    transform: "translate(2249.634 -1240.375)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M-2216.481,1245.707v-4.353a.763.763,0,0,1,.778-.765.76.76,0,0,1,.765.765v4.29c0,1.631.84,2.5,2.22,2.5s2.208-.815,2.208-2.433v-4.353a.763.763,0,0,1,.778-.765.76.76,0,0,1,.765.765v4.277c0,2.622-1.48,3.939-3.776,3.939S-2216.481,1248.253-2216.481,1245.707Z",
    transform: "translate(2226.152 -1240.527)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M-2180.662,1248.3a.724.724,0,0,1-.3-.589.717.717,0,0,1,.728-.715.716.716,0,0,1,.452.138,3.806,3.806,0,0,0,2.458.9c.954,0,1.556-.452,1.556-1.1v-.025c0-.627-.352-.966-1.982-1.342-1.869-.452-2.923-1-2.923-2.622v-.025c0-1.505,1.254-2.546,3-2.546a4.83,4.83,0,0,1,2.785.815.7.7,0,0,1,.339.615.717.717,0,0,1-.728.715.747.747,0,0,1-.4-.113,3.651,3.651,0,0,0-2.019-.665c-.9,0-1.43.464-1.43,1.041v.025c0,.677.4.979,2.095,1.38,1.856.452,2.81,1.116,2.81,2.572v.025c0,1.643-1.292,2.622-3.136,2.622A5.467,5.467,0,0,1-2180.662,1248.3Z",
    transform: "translate(2200.995 -1240.375)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M-2147.5,1242.234h-2.132a.715.715,0,0,1-.715-.715.715.715,0,0,1,.715-.715h5.833a.712.712,0,0,1,.7.715.712.712,0,0,1-.7.715h-2.145v6.648a.771.771,0,0,1-.778.765.771.771,0,0,1-.778-.765Z",
    transform: "translate(2179.311 -1240.679)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M-2121.222,1248.277l3.261-7.275a.978.978,0,0,1,.928-.627h.075a.962.962,0,0,1,.916.627l3.261,7.275a.674.674,0,0,1,.088.326.723.723,0,0,1-.728.74.794.794,0,0,1-.752-.539l-.715-1.643h-4.265l-.74,1.693a.742.742,0,0,1-.715.489.707.707,0,0,1-.715-.715A.789.789,0,0,1-2121.222,1248.277Zm5.745-2.484-1.543-3.55-1.543,3.55Z",
    transform: "translate(2158.753 -1240.375)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M-2081.418,1241.354a.763.763,0,0,1,.778-.765.76.76,0,0,1,.765.765v7.376a.76.76,0,0,1-.765.765.763.763,0,0,1-.778-.765Z",
    transform: "translate(2130.489 -1240.527)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M-2063.789,1241.379a.774.774,0,0,1,.778-.778h.163a.972.972,0,0,1,.8.452l4.39,5.682v-5.394a.755.755,0,0,1,.753-.753.758.758,0,0,1,.765.753v7.376a.75.75,0,0,1-.753.765h-.063a.971.971,0,0,1-.8-.464l-4.516-5.845v5.569a.755.755,0,0,1-.753.753.758.758,0,0,1-.765-.753Z",
    transform: "translate(2118.003 -1240.527)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M-2027.483,1248.277l3.261-7.275a.978.978,0,0,1,.928-.627h.075a.962.962,0,0,1,.916.627l3.261,7.275a.668.668,0,0,1,.088.326.723.723,0,0,1-.728.74.8.8,0,0,1-.753-.539l-.715-1.643h-4.265l-.74,1.693a.742.742,0,0,1-.715.489.707.707,0,0,1-.715-.715A.789.789,0,0,1-2027.483,1248.277Zm5.745-2.484-1.543-3.55-1.543,3.55Z",
    transform: "translate(2092.359 -1240.375)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M-1987.98,1241.582a.766.766,0,0,1,.777-.778h3.161a3.17,3.17,0,0,1,2.3.778,1.967,1.967,0,0,1,.59,1.455v.025a2.091,2.091,0,0,1-1.254,1.957,2.153,2.153,0,0,1,1.744,2.132v.025c0,1.568-1.292,2.408-3.249,2.408h-3.286a.766.766,0,0,1-.777-.778Zm3.625,2.923c.991,0,1.656-.389,1.656-1.192v-.025c0-.69-.552-1.116-1.543-1.116h-2.22v2.333Zm.451,3.713c1.054,0,1.693-.414,1.693-1.2v-.025c0-.74-.59-1.179-1.806-1.179h-2.446v2.408Z",
    transform: "translate(2064.309 -1240.679)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M-1952.334,1241.354a.763.763,0,0,1,.778-.765.76.76,0,0,1,.765.765v7.376a.76.76,0,0,1-.765.765.763.763,0,0,1-.778-.765Z",
    transform: "translate(2039.061 -1240.527)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M-1934.7,1241.354a.763.763,0,0,1,.778-.765.76.76,0,0,1,.765.765v6.673h3.976a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7h-4.741a.766.766,0,0,1-.778-.778Z",
    transform: "translate(2026.574 -1240.527)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M-1903.487,1241.354a.763.763,0,0,1,.778-.765.76.76,0,0,1,.765.765v7.376a.76.76,0,0,1-.765.765.763.763,0,0,1-.778-.765Z",
    transform: "translate(2004.464 -1240.527)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M-1885.376,1242.234h-2.132a.715.715,0,0,1-.715-.715.715.715,0,0,1,.715-.715h5.833a.712.712,0,0,1,.7.715.712.712,0,0,1-.7.715h-2.145v6.648a.771.771,0,0,1-.778.765.771.771,0,0,1-.778-.765Z",
    transform: "translate(1993.653 -1240.679)",
    fill: "#273943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M-1852.989,1245.99l-3.023-4.152a.954.954,0,0,1-.176-.539.751.751,0,0,1,.778-.74.888.888,0,0,1,.752.464l2.446,3.525,2.484-3.537a.885.885,0,0,1,.74-.464.732.732,0,0,1,.753.753.936.936,0,0,1-.213.552l-3,4.1v2.747a.763.763,0,0,1-.778.765.76.76,0,0,1-.765-.765Z",
    transform: "translate(1970.963 -1240.496)",
    fill: "#273943"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInceptLogo);
export default __webpack_public_path__ + "static/media/incept_logo.2cea3a72087492f683db6909bd7ab348.svg";
export { ForwardRef as ReactComponent };